import { format, parseISO } from 'date-fns'

/** Snap any date to the Monday of its ISO week (Mon = day 1, Sun = 7).
 *  Used by "Check a week" to default to the current week, and by the
 *  prev/next-week buttons to walk by 7-day windows. */
export function isoMondayOf(date: Date): string {
  const d = new Date(date)
  d.setHours(0, 0, 0, 0)
  const day = d.getDay() // 0=Sun … 6=Sat
  // Distance back to Monday. Sun (0) → -6, Mon (1) → 0, … Sat (6) → -5.
  const delta = day === 0 ? -6 : 1 - day
  d.setDate(d.getDate() + delta)
  return d.toISOString().slice(0, 10)
}

export function shiftIsoWeek(isoMonday: string, weeks: number): string {
  const d = parseISO(isoMonday)
  d.setDate(d.getDate() + weeks * 7)
  return d.toISOString().slice(0, 10)
}

export function fmtWeekLabel(isoMonday: string): string {
  const start = parseISO(isoMonday)
  const end = new Date(start)
  end.setDate(end.getDate() + 6)
  // Full "dd MMM yyyy" on both endpoints — "25 May 2026 – 31 May 2026".
  return `${format(start, 'dd MMM yyyy')} – ${format(end, 'dd MMM yyyy')}`
}

export function fmtDayHeader(iso: string): { weekday: string; dayNum: number } {
  const d = parseISO(iso)
  return { weekday: format(d, 'EEE'), dayNum: d.getDate() }
}
